<!--
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2021-03-29 14:34:32
 * @LastEditTime: 2021-03-29 15:41:17
 * @LastEditors: zhaoshuai
-->
<template>
  <div class="flex sharing-v">
    <Header />
    <secondStep titleMsg="报名记录" />
    <div class="pay-wrapper">
      <a-icon type="check-circle" class="icon-css" theme="filled" />

      <p class="suc-pay">补考成功</p>
      <p class="remind-pay">请关注项目网站或官方微信公众号发布的最新评定资讯</p>
    </div>
    <a
      href="/secondInfomation?lookMsg=1"
      style="color: #1890ff; text-align: center; margin-top: 50px"
      >查看我的报名信息</a
    >
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
import secondStep from "../components/common/secondStep";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("apply");

export default {
  name: "waitPay",
  components: {
    Header,
    secondStep,
  },
  data() {
    return {
    }
  },
  mounted() {
    // let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    // this.getStudentInfo({
    //   orderCode: userInfo.orderCode,
    //   userCode: userInfo.userCode,
    // }).then((res) => {
    //   let studentInfo = res.data.data;
    //   this.userInfo = studentInfo;
    //   this.$previewRefresh();
    // });
  },
  methods: {
    ...mapActions(["getStudentInfo", "updateStudentAction"]),
  }
};
</script>

<style scoped>
.pay-wrapper {
  text-align: center;
  padding: 50px 50px;
  background: #f5f5f5;

  margin: 0 auto;
  margin-top: 40px;
}
.pay-price {
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 30px;
  color: #000;
}
.pay-price span {
  color: #b01f21;
  font-size: 48px;
}
.pay-way {
  color: #b01f21;
  font-size: 16px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.suc-pay {
  font-size: 24px;
  color: #000;
  margin-bottom: 20px;
}
.remind-pay {
  font-size: 14px;
  color: #333;
}
.icon-css {
  font-size: 48px;

  margin-bottom: 30px;
  color: #b01f21;
}
</style>